import { render, staticRenderFns } from "./MealPlanListView.vue?vue&type=template&id=5fc2bb9c&scoped=true"
import script from "./MealPlanListView.vue?vue&type=script&lang=js"
export * from "./MealPlanListView.vue?vue&type=script&lang=js"
import style0 from "./MealPlanListView.vue?vue&type=style&index=0&id=5fc2bb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc2bb9c",
  null
  
)

export default component.exports